import React, { useEffect } from "react";
import { autorun } from "mobx";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../_stores";
import { TextField } from "@material-ui/core";
import { settingStyles } from "../Styles/SettingStyles";
import { Notification } from '../../../core/Notification';
import { useTranslation } from "react-i18next";
import Progress from "../../../core/Progress";
import QRCode from "react-qr-code";


const Secure = observer(() => {
    const {t} = useTranslation();
    const classes = settingStyles();
    const translate = (name: string) => t('setting.' + name);
    const {secureStore} = useStores();
    let src: "";

    useEffect(() => {
        autorun(async () => {
            await secureStore.loadSecureInfo();
        });
    }, []);

    return(
        <div>
            <Progress isLoading = {secureStore.isLoading}/>
            <TextField
                className={classes.elementAddress}
                label={"Код установки"/*translate("objects.address")*/}
                value={secureStore.code}
                onChange={(event) => secureStore.code = event.target.value}
             />
            <br/>
            <TextField
                className={classes.elementAddress}
                label={"Код сервисами"/*translate("objects.address")*/}
                value={secureStore.codeServices}
                onChange={(event) => secureStore.codeServices = event.target.value}
             />
            <br/>
            <h3>{"Ссылка для активации"}</h3>
            <a href={secureStore.fullAddress}>{secureStore.fullAddress}</a>
            <br/>
            <h3>{"QR code для активации"}</h3>
            <QRCode value={secureStore.fullAddress}/>
            {<Notification
                isOpen={secureStore.isNotification}
                close={() => secureStore.isNotification = false}
                okClick={() => secureStore.isNotification = false}
                questionText={secureStore.message}
            />}
        </div>
    );
});

export default Secure;